import { LatestLeadResponse } from "@/entities/lead/api/types";
import { LeadProps } from "@/entities/lead/model/types";
import { LoanInfoProps } from "@/entities/loan/model/types";
import { ProfileProps } from "@/entities/profile/types";

export enum RouterPath {
  Login = "/login",
  Cabinet = "/cabinet",
  Profile = "/profile",
  History = "/history",
  LeadBiometry = "/lead-biometry",
  LeadApply = "/lead-apply",
  LeadSign = "/lead-sign",
  ProfileRefill = "/profile-refill",
  LoanRepeat = "/loan-repeat",
  LoanSubmit = "/loan-submit",
  LoanBiometry = "/loan-biometry",
  Payment = "/payment",
}

export enum NavigateState {
  LoanRepeat = "LoanRepeat",
}

export interface CabinetLoaderData {
  profile?: ProfileProps;
  latestLead?: LatestLeadResponse;
  loanInfo?: LoanInfoProps;
}

export type CabinetLoaderResponse = CabinetLoaderData;

export type PaymentLoaderResponse = {
  loanInfo: LoanInfoProps;
};

export interface MediationLoaderResponse {
  latestLead: LeadProps;
  loanInfo: LoanInfoProps;
}

export interface RefinanceLoaderResponse {
  latestLead: LeadProps;
  loanInfo: LoanInfoProps;
}
